'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
require('../../DataDisplays/Avatar/Avatar.js');
require('tailwind-merge');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');
var Input = require('./Input.js');

const PasswordInput = react.forwardRef((_a, ref)=>{
    var { type, disabled } = _a, rest = _tslib.__rest(_a, [
        "type",
        "disabled"
    ]);
    const [isPasswordVisible, setIsPasswordVisible] = react.useState(false);
    const handlePasswordVisibility = (e)=>{
        e.preventDefault();
        setIsPasswordVisible((pre)=>!pre);
    };
    return jsxRuntime.jsxs(Box, {
        className: "flex w-full items-center gap-2",
        "data-testid": "design-system--password-input",
        children: [
            jsxRuntime.jsx(Input, Object.assign({
                type: isPasswordVisible ? 'text' : 'password',
                ref: ref
            }, rest, {
                disabled: disabled
            })),
            jsxRuntime.jsx("button", {
                onClick: handlePasswordVisibility,
                disabled: disabled,
                className: disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                type: "button",
                children: jsxRuntime.jsx(SystemIcon, {
                    name: isPasswordVisible ? 'medium_eye_slash' : 'medium_eye',
                    className: "text-w-gray-400"
                })
            })
        ]
    });
});
PasswordInput.displayName = 'PasswordInput';

module.exports = PasswordInput;
